import * as React from 'react';
import { useNavigate } from 'react-router-dom';
import { Box, Typography } from '@mui/material';
import { CustomerSitesReadDTO } from '../../generated/api-client';
import { useCustomerSitesByCustomerId } from '../../hooks';
import { ReadOnlyDataGrid, ReadOnlyField, RowAction } from '../ReadOnlyDataGrid';
import EditIcon from '@mui/icons-material/Edit';
import DeleteIcon from '@mui/icons-material/DeleteOutline';
import { useDeleteCustomerSites } from '../../hooks/useCustomerSites';
import { ConfirmDialog } from '../common/ConfirmDialog';

interface CustomerDetailSitesTabProps {
  customerId: string;
}

export const CustomerDetailSitesTab: React.FC<CustomerDetailSitesTabProps> = ({ customerId }) => {
  const navigate = useNavigate();
  const { data: sites = [], isLoading, error } = useCustomerSitesByCustomerId(customerId);
  const deleteMutation = useDeleteCustomerSites();
  const [deleteState, setDeleteState] = React.useState<{ open: boolean; id: string | null }>({
    open: false,
    id: null,
  });

  const fields: ReadOnlyField[] = [
    {
      field: 'address',
      headerName: 'Indirizzo',
      width: 300,
    },
    {
      field: 'covered_area',
      headerName: 'Area Coperta (m²)',
      width: 150,
      type: 'number',
    },
    {
      field: 'last_update',
      headerName: 'Ultimo Aggiornamento',
      width: 200,
      type: 'dateTime',
    },
  ];

  const actions: RowAction[] = [
    {
      label: 'Apri',
      icon: <EditIcon />,
      onClick: (id, row) => {
        navigate(`/sites/${id}`);
      },
    },
    {
      label: 'Elimina',
      icon: <DeleteIcon />,
      onClick: id => {
        setDeleteState({ open: true, id: String(id) });
      },
    },
  ];

  if (error) {
    return (
      <Box sx={{ p: 2 }}>
        <Typography color="error">Errore nel caricamento dei siti</Typography>
      </Box>
    );
  }

  return (
    <>
      <Box sx={{ p: 2 }}>
        <Typography variant="h6" gutterBottom>
          Siti
        </Typography>
        <ReadOnlyDataGrid
          fields={fields}
          data={sites}
          actions={actions}
          loading={isLoading}
          height="calc(100vh - 350px)"
          getId={row => row.id || ''}
        />
      </Box>
      <ConfirmDialog
        open={deleteState.open}
        title="Conferma eliminazione"
        content="Sei sicuro di voler eliminare questo sito?"
        confirmText="Elimina"
        cancelText="Annulla"
        loading={deleteMutation.isLoading}
        onCancel={() => setDeleteState({ open: false, id: null })}
        onConfirm={() => {
          if (deleteState.id) {
            deleteMutation.mutate(deleteState.id, {
              onSettled: () => setDeleteState({ open: false, id: null }),
            });
          }
        }}
      />
    </>
  );
};
